/**
 * @module store/user/mutations
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Установка пользователя
   *
   * @since Version 1.0.0
   */
  [types.SET_USER](state, user) {
    state.user = user;
  },


  /**
   * Mutation: Логаут пользователя
   *
   * @since Version 1.0.0
   */
  [types.LOGOUT_USER](state) {
    state.user = null;
  },
};
/* eslint-enable no-param-reassign */
